const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals')
      .then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
        onCLS(onPerfEntry);
        onFCP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
        if (onINP) onINP(onPerfEntry);
      })
      .catch((err) => {
        console.warn('Failed to load web-vitals:', err);
      });
  }
};

export default reportWebVitals;
